/**
 * Vocabulario do dominio — a grafia oficial, num lugar so.
 *
 * Os seis status abaixo sao os UNICOS permitidos pelo manual da marca (p.09 e
 * skill `style`). "Ativo", "Ocioso" e "Inativo" nao existem neste sistema. O
 * guia de construcao lista nove estados; os quatro extras (`Aguardando peca`,
 * `Aguardando operacao`, `Sem contrato`, `Mobilizacao`) entram como MOTIVO
 * dentro do status, nunca como status novo.
 */

export const STATUS_EQUIPAMENTO = [
  'Operando',
  'Standby',
  'Parada',
  'Em manutenção',
  'Disponível',
  'Em deslocamento',
] as const;

export type StatusEquipamento = (typeof STATUS_EQUIPAMENTO)[number];

export function ehStatusEquipamento(valor: unknown): valor is StatusEquipamento {
  return (
    typeof valor === 'string' &&
    (STATUS_EQUIPAMENTO as readonly string[]).includes(valor)
  );
}

/**
 * Prioridade de atendimento — a fila da oficina, nao o estado da maquina.
 *
 * ATENCAO, ISTO E PENDENCIA: a escala abaixo NAO esta no manual da marca nem
 * no backlog como campo. Ela entrou porque o sistema de componentes pede um
 * `BadgePrioridade`, e badge sem vocabulario e desenho, nao componente. Os tres
 * niveis sao os da conversa de obra ("essa e alta, essa pode esperar"), mas
 * quem decide a grafia oficial e o dono — do mesmo jeito que decidiu os seis
 * status.
 *
 * O que NAO foi inventado junto: cor. As cores de status sao exclusivas do
 * status (p.09), e nao existe escala de cor de prioridade. Por isso o badge de
 * prioridade e de contorno neutro e quem carrega o significado e a palavra.
 */
export const PRIORIDADES = ['Alta', 'Média', 'Baixa'] as const;

export type Prioridade = (typeof PRIORIDADES)[number];

/**
 * Cor de cada status, sempre por token — nunca hexadecimal na tela.
 *
 * Selo preenchido da R02 (p.31): fundo na tinta, ponto na cor 500, texto no
 * tom escuro do mesmo status. O exemplo da R02 desenha `Em manutenção` em
 * laranja e `Disponível` em azul, e o dono confirmou em 26/09/2026 que vale a
 * R02 — a regra "laranja nao e status" da p.09 caiu.
 *
 * `Em deslocamento` ganhou cor propria na v2.1 (p.12): o violeta — antes ele
 * reaproveitava o cinza do nao alocado.
 */
export const CORES_DO_STATUS: Record<
  StatusEquipamento,
  { readonly ponto: string; readonly fundo: string; readonly texto: string }
> = {
  Operando: { ponto: 'bg-operando', fundo: 'bg-operando-fundo', texto: 'text-operando-texto' },
  Standby: { ponto: 'bg-standby', fundo: 'bg-standby-fundo', texto: 'text-standby-texto' },
  Parada: { ponto: 'bg-parada', fundo: 'bg-parada-fundo', texto: 'text-parada-texto' },
  'Em manutenção': { ponto: 'bg-manutencao', fundo: 'bg-manutencao-fundo', texto: 'text-manutencao-texto' },
  Disponível: { ponto: 'bg-disponivel', fundo: 'bg-disponivel-fundo', texto: 'text-disponivel-texto' },
  'Em deslocamento': { ponto: 'bg-deslocamento', fundo: 'bg-deslocamento-fundo', texto: 'text-deslocamento-texto' },
};
